import { TabPill } from 'types/tabs';

export enum LeadSettingIds {
  CALENDAR_CONFERENCING = 'calendar-conferencing'
}

export const leadSettingsTabs: TabPill[] = [
  { id: LeadSettingIds.CALENDAR_CONFERENCING, label: 'Calendar & Conferencing' }
];
